<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center" >
        <div class="col-12 text-center" >
          <h1 class="circle" >3</h1>
          <h2>RETRIEVED DATA FROM THE ID CARD</h2>
        </div>
        <div class="col-12" id="cedula">
          <div id="datos">
            <span class="idnumber"> {{data.nationalRegistrationNumber}} </span>
            <span class="surname"> {{data.lastName}} </span>
            <span class="name"> {{data.givenName}} </span>
            <div class="inline-data"></div>
            <span class="birth"> {{formatDate(data.dateOfBirth)}} </span>
            <span class="expiry"> {{formatDate(data.expirationDate)}} </span>
            <span class="otherdata"> {{data.docNumber}} </span>
            <span class="sex"> {{data.sex}} </span>
            <span class="nationality"> {{data.nationality}} </span>
          </div>
          <div id="foto">
            <img :src="'data:image/png;base64,'+data.image" alt="">
          </div>
        </div>
        <div class="col-12" id="button-ok-final">
          <a class="btn btn-comenzar" href="#" @click="toIndex">BACK</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StepTwo",
  props:{
    data: {}
  },methods: {
    formatDate(value) {
      if (!value) {
        return '';
      }

      const date = String(value).trim();
      const isoDate = date.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);

      if (isoDate) {
        return `${isoDate[2].padStart(2, '0')}-${isoDate[3].padStart(2, '0')}-${isoDate[1]}`;
      }

      const englishDate = date.match(/^([A-Za-z]{3,9})\s+(\d{1,2}),?\s+(\d{4})$/);
      if (englishDate) {
        const months = {
          jan: '01', feb: '02', mar: '03', apr: '04',
          may: '05', jun: '06', jul: '07', aug: '08',
          sep: '09', oct: '10', nov: '11', dec: '12'
        };
        const month = months[englishDate[1].slice(0, 3).toLowerCase()];

        if (month) {
          return `${month}-${englishDate[2].padStart(2, '0')}-${englishDate[3]}`;
        }
      }

      return date;
    },
    toIndex(){
      this.$emit('nextStep','MainContent');
    }
  },emits: ['nextStep'],
}
</script>

<style scoped>
</style>
